import React, { Component } from 'react';

class DesignStudioRemoteAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iframeSrc: null, // Default URL
        };
    }

    // componentDidMount = () => {
    //     const searchParams = new URLSearchParams(window.location.search)
    //     const port = searchParams.get("port")
    //     const project_id = searchParams.get("project_id")
    //     this.setState({
    //         iframeSrc: `https://ds${port}.okas.one/`, // Change to a different URL
    //     });
    //     // alert(`http://proxy${port}.tft.design/`)
    // }

    componentDidMount = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const port = searchParams.get("port");
        const project_id = searchParams.get("project_id");

        const iframeSrc =
            port && port != "null"
                ? `https://proxy${port}.okas.in`
                : `https://ds${project_id}.okas.one`;

        this.setState({
            iframeSrc: iframeSrc,
        });
    };



    render() {
        return (
            <div
                style={{
                    width: '100%',
                }}
            >
                <iframe
                    src={this.state.iframeSrc}
                    title="External Content"
                    height="570"
                    style={{
                        marginLeft: '-50px',          // Shift the iframe left
                        width: 'calc(100% + 50px)',   // Compensate for the negative margin
                        border: 'none',               // Remove border
                        outline: 'none',              // Remove outline for focus
                        borderRadius: '4px',          // Match container styling
                    }}
                ></iframe>
            </div>

        );
    }
}

export default DesignStudioRemoteAccess;

